import { cloneDeep } from 'lodash';
import { initialState } from './initial-state';
export var setTwoFaTempUser = function (state, action) {
    var nextState = cloneDeep(state);
    var _a = action.payload, user = _a.user, token = _a.token, expiresAt = _a.expiresAt;
    nextState.temporaryUser = user;
    nextState.temporaryToken = token;
    nextState.temporaryTokenExpiresAt = expiresAt;
    return nextState;
};
export var setRedirectObject = function (state, action) {
    var nextState = cloneDeep(state);
    nextState.redirectObject = action.payload;
    return nextState;
};
export var resetTemporaryTwoFaUser = function (state) {
    var nextState = cloneDeep(state);
    nextState.temporaryUser = initialState.temporaryUser;
    nextState.temporaryToken = initialState.temporaryToken;
    nextState.temporaryTokenExpiresAt = initialState.temporaryTokenExpiresAt;
    return nextState;
};
export var setTwoFaReturnLoginUrl = function (state, action) {
    var nextState = cloneDeep(state);
    nextState.loginUrl = action.payload;
    return nextState;
};
